export interface ContactData {
  title: string;
  subtitle: string;
  email: string;
  phone?: string;
  address?: string;
  formFields: {
    name: {
      label: string;
      placeholder: string;
      required: boolean;
    };
    email: {
      label: string;
      placeholder: string;
      required: boolean;
    };
    message: {
      label: string;
      placeholder: string;
      required: boolean;
    };
  };
  submitButtonText: string;
  successMessage: string;
  errorMessage: string;
}

export const contactData: ContactData = {
  title: "Get in Touch",
  subtitle: "Let's discuss your next project or just say hello!",
  email: "tranducgiangact@gmail.com",
  phone: "+84 339488855",
  address: "Van Quan, Ha Dong, Ha Noi",
  formFields: {
    name: {
      label: "Name",
      placeholder: "Enter your name",
      required: true,
    },
    email: {
      label: "Email",
      placeholder: "Enter your email",
      required: true,
    },
    message: {
      label: "Message",
      placeholder: "Tell me about your project or just say hello...",
      required: true,
    },
  },
  submitButtonText: "Send Message",
  successMessage: "Thank you for your message! I'll get back to you soon.",
  errorMessage:
    "Sorry, there was an error sending your message. Please try again or contact me directly.",
};
